import React, { useEffect, useState } from 'react';
import { 
  Card, 
  CardContent, 
  CardHeader, 
  Divider, 
  Grid, 
  Typography, 
  CircularProgress, 
  Box 
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'src/utils/axios';
import { loadUrunControlDetail } from 'src/utils/storage/StartWorkOrder';
import { text } from '../../modules/languages/index';
import Alert from '@material-ui/lab/Alert';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  label: {
    fontWeight: 'bold',
    color: theme.palette.text.secondary
  },
  value: {
    color: theme.palette.text.primary,
    textAlign: 'right'
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(3)
  }
}));

function ProductWarranty({ className }) {
  const classes = useStyles();
  const [garantiData, setGarantiData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

 useEffect(() => {
    let mounted = true;
    const storeData = loadUrunControlDetail();

    // 1. HATA KONTROLÜ: Local storage verisi var mı ve beklenen formatta mı?
    const currentItem = storeData && storeData[0];

    if (!currentItem || !currentItem.UYIL || !currentItem.UDONEM || !currentItem.SERINO) {
      logger.warn("Garanti bilgisi için gerekli parametreler eksik:", currentItem);
      setError("Ürün bilgileri eksik olduğu için garanti detayı alınamadı.");
      setIsLoading(false);
      return; // Parametreler eksikse API isteğini hiç başlatma
    }

    const { KUL_MODEL_KODU, UYIL, UDONEM, SERINO } = currentItem;

    const fetchWarranty = async () => {
      try {
        setIsLoading(true);
        // Parametreleri güvenli bir şekilde oluştur (null/undefined kontrolü)
        const modelKodu = KUL_MODEL_KODU || '-1';
        const url = `/GetArtemisWarranty/${modelKodu}/${UYIL}/${UDONEM}/${SERINO}/1`;

        const response = await axios.get(url);

        if (mounted) {
          if (response.data && response.data.length > 0) {
            setGarantiData(response.data[0]);
            setError(null);
          } else {
            setError("Bu ürün için kayıtlı bir garanti bilgisi bulunamadı.");
          }
        }
      } catch (err) {
        if (mounted) {
          // 2. HATA KONTROLÜ: API hatası durumunda kullanıcıya bilgi ver
          setError("Garanti bilgileri sunucudan alınırken bir hata oluştu.");
          logger.error("API Hatası:", err);
        }
      } finally {
        if (mounted) setIsLoading(false);
      }
    };

    fetchWarranty();
    return () => { mounted = false; };
  }, []);

  // İçerik Oluşturucu Fonksiyon
  const renderContent = () => {
    if (isLoading) {
      return (
        <Box className={classes.loadingContainer}>
          <CircularProgress size={24} />
          <Typography style={{ marginLeft: 10 }}>{text("Yükleniyor...")}</Typography>
        </Box>
      );
    }

    if (error) {
      return <Alert severity="info">{error}</Alert>;
    }

    const fields = [
      { label: "Garanti Tipi", value: garantiData?.GARANTI_TIPI_TEXT },
      { label: "Başlangıç Tarihi", value: garantiData?.GARANTI_BASLANGIC_TARIHI },
      { label: "Bitiş Tarihi", value: garantiData?.GARANTI_BITIS_TARIHI },
      { label: "Ek Garanti Başlangıç", value: garantiData?.EK_GARANTI_BASLANGIC_TARIHI },
      { label: "Ek Garanti Bitiş", value: garantiData?.EK_GARANTI_BITIS_TARIHI },
    ];

    return (
      <Grid container spacing={2}>
        {fields.map((field, index) => (
          <React.Fragment key={index}>
            <Grid item xs={7}>
              <Typography className={classes.label}>{field.label} :</Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography className={classes.value}>
                {field.value || "---"}
              </Typography>
            </Grid>
            {index < fields.length - 1 && (
              <Grid item xs={12}>
                <Divider light />
              </Grid>
            )}
          </React.Fragment>
        ))}
      </Grid>
    );
  };

  return (
    <Card className={clsx(classes.root, className)}>
      <CardHeader 
        title={<Typography variant="h6">{text("Garanti_Detay")}</Typography>} 
      />
      <Divider />
      <CardContent>
        {renderContent()}
      </CardContent>
    </Card>
  );
}

ProductWarranty.propTypes = {
  className: PropTypes.string,
};

export default connect(state => ({
  tasks: state.tasks1,
}))(ProductWarranty);